import $ from 'jquery';
import Swiper from 'swiper';

export default class ProductComparison {
  constructor() {
    this.$body = $('body');
    this.mSwiper = false;
    this.modifyDOM();
    this.addEvents();
  }

  modifyDOM() {
    this.initSlider();
  }

  addEvents() {
    $(window).on('resize', this.initSlider.bind(this));

    $('.gallery-thumbs').on('click', '.swiper-slide', (e) => {
      this.mSwiper[1].slideTo($(e.target).index(), 500);
    });
  }

  initSlider() {
    if (this.$body.hasClass('phone') && !this.mSwiper) {
      const galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

      this.mSwiper = new Swiper('.product-comparison__container', {
        loop: false,
        slidesPerView: 'auto',
        thumbs: {
          swiper: galleryThumbs,
        },
      });
    } else if (typeof this.mSwiper !== 'undefined' && this.mSwiper) {
      this.mSwiper.destroy();
      this.mSwiper = false;
    }
  }
}
